import type {UploadTicket} from '@hc/base'

export interface PostTarget {
  url: string
  headers: Record<string, string>
  /** form fields sent before the file */
  fields: Record<string, string>
}

/** direct (or missing mode, backwards compatible): object storage with signed fields; server: app endpoint with bearer token */
export function resolvePostTarget(ticket: UploadTicket, resolveServerUrl: (path: string) => string, jwt: string): PostTarget {
  if (ticket.mode === 'server') {
    return {url: resolveServerUrl(ticket.url), headers: {Authorization: `Bearer ${jwt}`}, fields: {}}
  }
  return {url: ticket.url, headers: {}, fields: ticket.fields}
}
